import React from "react";
import { Chip } from "@heroui/react";
import { Icon } from "@iconify/react";

interface StatusBadgeProps {
  status: "idle" | "running" | "success" | "error";
  isCurrentStep: boolean;
}

const statusConfig = {
  idle: {
    color: "default" as const,
    icon: "solar:clock-circle-linear",
    label: "Idle",
  },
  running: {
    color: "warning" as const,
    icon: "solar:refresh-circle-linear",
    label: "Running",
  },
  success: {
    color: "success" as const,
    icon: "solar:check-circle-linear",
    label: "Done",
  },
  error: {
    color: "danger" as const,
    icon: "solar:close-circle-linear",
    label: "Error",
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, isCurrentStep }) => {
  const config = statusConfig[status];

  return (
    <Chip
      className={`transition-all duration-300 ${
        isCurrentStep ? "ring-2 ring-primary-500 ring-offset-1 scale-110" : ""
      }`}
      color={config.color}
      size="sm"
      startContent={
        <Icon
          className={`w-3.5 h-3.5 ${status === "running" ? "animate-spin" : ""}`}
          icon={config.icon}
        />
      }
      variant={isCurrentStep ? "solid" : "flat"}
    >
      {config.label}
    </Chip>
  );
};
